import React from 'react';

const DftCourse = () => {
    return (
        <div className="course-detail-page">
            <section className="detail-hero" data-aos="fade-up">
                <h1>DFT <span>Design for Testability</span></h1>
                <p>Master scan insertion, ATPG, and BIST methodologies.</p>
            </section>

            <section className="detail-content" style={{ textAlign: 'center', padding: '50px' }}>
                <div className="glass" data-aos="zoom-in" style={{ padding: '40px', display: 'inline-block' }}>
                    <h3>Coming Soon</h3>
                    <p style={{ color: 'var(--text-dim)', marginTop: '20px' }}>We are currently developing the comprehensive DFT curriculum. Stay tuned!</p>
                </div>
            </section>
        </div>
    );
};

export default DftCourse;